import React from 'react';
import config from 'config';
import {connect} from 'react-redux';

import {Button, Panel, Col, Row, Image} from 'react-bootstrap';
import {withRouter} from "react-router-dom";
import {FormattedMessage, FormattedHTMLMessage} from 'react-intl';

//APPs
import appRouter from '../../utils/appRouter';
import Utils from '../../utils/utils';
import GameApi from '../../api/game-api';
import UserApi from '../../api/user-api';
import ModalApi from '../../api/modal-api';

class Game extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			defaultLock: false,
			lastSelected: null
		};

		this.getGame = this.getGame.bind(this);
		this.answerQuestion = this.answerQuestion.bind(this);
		this.nextQuestion = this.nextQuestion.bind(this);
		this.showNewTicketModal = this.showNewTicketModal.bind(this);
		this.showExtraRoundModal = this.showExtraRoundModal.bind(this);
		this.showExtraRoundConfirm = this.showExtraRoundConfirm.bind(this);
		this.buyExtraRound = this.buyExtraRound.bind(this);
		this.checkGameStatus = this.checkGameStatus.bind(this);
	}

	isPath(path) {
		let regex = new RegExp('/' + path);
		return regex.test(this.props.history.location.pathname);
	}

	getGame() {
		if (this.state.defaultLock) return;
		this.setState({defaultLock: true});

		return GameApi.getGame(this.props.user.game).then(() => {
			this.setState({defaultLock: false});
		});
	}

	checkIfCanKeepPlaying(){
		if (!UserApi.canPlay(this.props.user)){
			this.props.history.push(appRouter.getLink('home'));
			return false;
		} else if (this.props.user.questionsAvailable <= 0) {
			this.showExtraRoundConfirm();
			return false;
		}
		return true;
	}

	answerQuestion(answerCode) {
		if (this.state.defaultLock || (this.props.game.questionsAvailable <= 0)) return;
		this.setState({defaultLock: true, lastSelected: answerCode});

		let params = {
			user: this.props.user,
			answerCode: answerCode + 1,
		};

		GameApi.answerQuestion(params).then(resp => {
			this.checkIfCanKeepPlaying();
			if (resp.error){
				UserApi.getUser(this.props.user.msisdn).then(() =>{
					this.nextQuestion();
				});
			}
		});
	}

	nextQuestion() {
		this.checkGameStatus();
		this.checkIfCanKeepPlaying();

		Utils.gaSend('Game', 'Botão', 'Próxima');

		if (this.props.game.questionsAvailable <= 0) return;

		GameApi.getGame(this.props.user.game).then(() => {
			this.setState({defaultLock: false, lastSelected: null});
		});
	}

	showNewTicketModal(cb) {
		ModalApi.showModal({
			closeClick: () => {
				UserApi.restoreScore(this.props.user);
				(cb) ? cb() : ModalApi.hideModal();
			},
			title: <FormattedHTMLMessage id="modal.newTicket.title"/>,
			description: <FormattedHTMLMessage id="modal.newTicket.description"/>,
			icon: 'icon-ticket.png',
			buttons: [
				{
					text: <FormattedHTMLMessage id="btn.continue"/>,
					click: () => {
						UserApi.restoreScore(this.props.user);
						(cb) ? cb() : ModalApi.hideModal();
					}
				}
			]
		})
	}

	showExtraRoundModal() {
		ModalApi.showModal({
			closeClick: () => {
				GameApi.resetGame();
				ModalApi.hideModal();
				Utils.gaSend('Rodada Extra', 'Botão', 'Fechar');
				this.props.history.push(appRouter.getLink('home'));
			},
			title: <FormattedHTMLMessage id="modal.extraRound.title"/>,
			description: <FormattedHTMLMessage id="modal.extraRound.description"/>,
			icon: 'icon-check.png',
			buttons: [
				{
					text: <FormattedHTMLMessage id="modal.extraRound.button.buy"/>,
					click: this.showExtraRoundConfirm
				}
			]
		})
	}

	showExtraRoundConfirm() {
		Utils.gaSend('Rodada Extra', 'Botão', 'Comprar');

		ModalApi.showModal({
			closeClick: () => {
				GameApi.resetGame();
				ModalApi.hideModal();
				this.props.history.push(appRouter.getLink('home'));
			},
			title: <FormattedHTMLMessage id="modal.extraRoundConfirm.title"/>,
			description: <FormattedHTMLMessage id="modal.extraRoundConfirm.description"/>,
			icon: 'icon-check.png',
			buttons: [
				{
					text: <FormattedHTMLMessage id="modal.extraRoundConfirm.button.buy"/>,
					click: this.buyExtraRound
				}
			]
		})
	}

	buyExtraRound() {
		Utils.gaSend('Rodada Extra', 'Botão', 'Continuar Jogando');

		GameApi.resetGame();
		GameApi.buyExtraRound(this.props.user.msisdn).then(() => {
			ModalApi.hideModal();

			if (!this.checkIfCanKeepPlaying()){
				return this.props.history.push(appRouter.getLink('home'));
			}

			if (this.isPath(appRouter.getLink('game'))) {
				this.setState({defaultLock: false, lastSelected: null});
			} else {
				this.props.history.push(appRouter.getLink('game'));
			}
		});
	}

	checkGameStatus(fromHome) {
		let callback = null;

		if (this.props.user.game.questionsAvailable <= 0) {
			if (this.props.user.game.gameStatus === config.constants.API.gameStatus.waiting_extra_round_answer) {
				if (fromHome) {
					this.showExtraRoundConfirm();
					return this.props.history.push(appRouter.getLink('home'));
				}
				callback = this.showExtraRoundConfirm;
			}
		}

		if (this.props.user.wonNewTicket) {
			this.showNewTicketModal(callback);
		} else if (callback) {
			callback();
		}
	}

	componentWillMount() {
		if (!this.props.user.msisdn) return;

		GameApi.startDaily(this.props.user.msisdn).then(user => {
			if (!this.checkIfCanKeepPlaying()) return;

			if (this.props.user.game.questionsAvailable > 0){
				this.getGame().then(() => {
					this.nextQuestion();
				});
			} else {
				this.checkGameStatus(true);
			}
		});
	}

	render() {

		// GAME
		let currentStep = this.props.game.currentStep;

		let lastAnsweredNum = null;
		if (this.props.user.game.lastAnswered) lastAnsweredNum = this.props.user.game.lastAnswered.correctAnswerWebNum;

		let questionsAvailable = Boolean(this.props.user.game.questionsAvailable);
		let isInRevision = Boolean(currentStep === config.constants.gameSteps.answerRevision);

		let gameResult = (this.props.game.isCorrect) ? 'correct' : 'wrong';
		let stampText = (this.props.game.isCorrect) ? 'correct.' + Utils.getARandomInteger(1, 2) : 'wrong.' + Utils.getARandomInteger(1, 2);
		let iconResult = (this.props.game.isCorrect) ? 'happy' : 'sad';

		let colCentered = (!(this.props.game.crossSelling.claroMusica && this.props.game.crossSelling.rbt) &&
		(this.props.game.crossSelling.claroMusica || this.props.game.crossSelling.rbt)) ? 'col-centered' : '';

		return (
			<div>
				<div className={'container-flex'}>
					<Col sm={12}>

						{!lastAnsweredNum &&
						<p className={'question-cheer-label'}>
							<FormattedHTMLMessage id="game.header.cheerPhrase"/>
						</p>
						}

						{isInRevision &&
						<div className={'question-stamp-label'}>
							<p>
								<FormattedHTMLMessage id={'game.revisionStampLabel.' + stampText}/>
							</p>
							<p>
								<FormattedHTMLMessage id={'game.revisionStampLabel'}/>
							</p>
						</div>
						}

						<Panel className={'panel-question-box' + ((isInRevision) ? ' in-review' : '')}
									 header={this.props.game.currentQuestion.longQuestion}>
							
								{isInRevision &&
								<div className={'question-stamp ' + gameResult}>									
									<p className={'stamp-text ' + gameResult}>
										<FormattedHTMLMessage id={'game.revisionStamp.' + stampText}/>
									</p>
								</div>
								}

								<div className={'answers-box ' + ((isInRevision) ? gameResult : '')}>
									{this.props.game.currentQuestion.answersWeb && this.props.game.currentQuestion.answersWeb.map((answer, i) =>
										<Button name="answer" key={i}
														className={((this.state.lastSelected === i) ? 'selected' : '')
														+ (((lastAnsweredNum !== this.state.lastSelected + 1) && (lastAnsweredNum === i + 1)) ? 'CorrectWrong' : '')}
														onClick={() => {
															this.answerQuestion(i)
														}}>
											{answer.answer}
											{isInRevision &&
											<div className={'icon-' + iconResult}></div>
											}
										</Button>
									)}
								</div>

								{(isInRevision) &&
								<Button className="next" onClick={this.nextQuestion}>
									<FormattedHTMLMessage id="btn.next"/>
								</Button>
								}
							
						</Panel>

						{(isInRevision && (this.props.game.crossSelling.claroMusica || this.props.game.crossSelling.rbt)) &&
						<Panel className={'panel-cross-selling'}>
							<Col md={12}>
								<Row>
									<h2>Aproveite também:</h2>
									{this.props.game.crossSelling.claroMusica &&
									<Col md={6} className={colCentered}>
										<div className="panel-cross-box">											
											<div className="conter-text">
												<div className="logo"><Image src={Utils.getImgPath() + "logo-claromusica.svg"} alt=""/></div>
												<p>
													<FormattedHTMLMessage id="game.crossSelling.claromusica"
													values={{
														link: this.props.game.crossSelling.claroMusica.link,
														text: this.props.game.crossSelling.claroMusica.text,
														onclick: () => Utils.gaSend('Cross-Selling', 'Claro Música', this.props.game.crossSelling.claroMusica.text)
													}} />
												</p>
											</div>
										</div>
									</Col>
									}
									{this.props.game.crossSelling.rbt &&
									<Col md={6} className={colCentered}>
										<div className="panel-cross-box">											
											<div className="conter-text">
												<div className="logo"><Image src={Utils.getImgPath() + "logo-clarosomdechamada.svg"} alt=""/>
												</div>
												<p>
													<FormattedHTMLMessage id="game.crossSelling.rbt"
													values={{
														link: this.props.game.crossSelling.rbt.link,
														text: this.props.game.crossSelling.rbt.text,
														onclick: () => Utils.gaSend('Cross-Selling', 'RBT', this.props.game.crossSelling.rbt.text)
													}}/>
												</p>
											</div>
										</div>
									</Col>
									}
								</Row>
							</Col>
						</Panel>
						}
					</Col>
				</div>
			</div>
		)
	}
}

const mapStateToProps = function (store) {
	return {
		user: store.userState,
		game: store.gameState,
	};
};

export default withRouter(connect(mapStateToProps)(Game));


// WEBPACK FOOTER //
// ./src/components/pages/game.component.jsx